var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"type":"button"}},[_vm._t("icon"),_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }